module.exports = __webpack_public_path__ + "static/demo11-33fc3cbaccfe55857bbccb7bb376d91e.png";